(function () {
  const ID_KEY = "riftbound-online-id";
  const NAME_KEY = "riftbound-online-name";

  const Online = window.RB.Online = window.RB.Online || {};

  function makeId() {
    return Math.random().toString(36).slice(2, 10) + Date.now().toString(36).slice(-4);
  }

  function playerId() {
    let id = null;
    try { id = localStorage.getItem(ID_KEY); } catch (e) { }
    if (!id) {
      id = makeId();
      try { localStorage.setItem(ID_KEY, id); } catch (e) { }
    }
    return id;
  }

  function playerName() {
    try { return localStorage.getItem(NAME_KEY) || ""; } catch (e) { return ""; }
  }

  function setPlayerName(name) {
    try { localStorage.setItem(NAME_KEY, name); } catch (e) { }
  }

  const Net = {
    ws: null,
    live: false,
    queue: [],
    onMessage: null,
    onReady: null,
    onDown: null,
    retry: null,
  };

  function wsUrl() {
    const proto = location.protocol === "https:" ? "wss:" : "ws:";
    return proto + "//" + location.host + "/ws";
  }

  function flush() {
    while (Net.live && Net.queue.length) Net.ws.send(JSON.stringify(Net.queue.shift()));
  }

  function connect() {
    if (Net.ws && (Net.ws.readyState === 0 || Net.ws.readyState === 1)) return;
    const ws = new WebSocket(wsUrl());
    Net.ws = ws;
    ws.onopen = function () {
      ws.send(JSON.stringify({ t: "hello", playerId: playerId(), name: playerName() || "Player" }));
    };
    ws.onmessage = function (ev) {
      let msg;
      try { msg = JSON.parse(ev.data); } catch (e) { return; }
      if (msg.t === "hello") {
        Net.live = true;
        flush();
        if (Net.onReady) Net.onReady();
        return;
      }
      if (Net.onMessage) Net.onMessage(msg);
    };
    ws.onclose = function () {
      if (Net.ws !== ws) return;
      Net.live = false;
      if (Net.onDown) Net.onDown();
      if (Net.retry) clearTimeout(Net.retry);
      Net.retry = setTimeout(connect, 1500);
    };
    ws.onerror = function () { };
  }

  function send(msg) {
    Net.queue.push(msg);
    if (!Net.live) connect();
    else flush();
  }

  function api(method, path, body) {
    return fetch(path, {
      method: method,
      headers: body ? { "Content-Type": "application/json" } : undefined,
      body: body ? JSON.stringify(body) : undefined,
    }).then(function (r) {
      return r.json().then(function (j) {
        if (!r.ok) throw new Error(j && j.error ? j.error : "request failed");
        return j;
      });
    });
  }

  function go(path) { location.href = path; }

  Object.assign(Online, {
    Net: Net,
    connect: connect,
    send: send,
    api: api,
    go: go,
    playerId: playerId,
    playerName: playerName,
    setPlayerName: setPlayerName,
  });
})();
